import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../__styling'

export const AppContentSection = styled('div')(({ theme }) => ({
    margin: '0 auto',
    padding: calcRem(0, 16),
    height: 'fit-content',
    width: '100%',
    display: 'flex',

    zIndex: 1,
    position: 'relative',

    // Make sure on phones content goes in a downwards direction
    flexDirection: 'column',

    // Apply the width to the mainContentWidth for non-mobile views
    // as well as applying the row direction
    [breakpoint('sm')]: {
        width: theme.siteMetrics.mainContentWidth,
        padding: calcRem(0, 64),

        flexDirection: 'row',
    },
}))
